import { mutator } from "satcheljs";
import { shiftRequestStore } from "../";
import updateRequestsNextCursorInStore from "../actions/updateRequestsNextCursorInStore";

/**
 * Update next cursor in shift request store
 */
export default mutator(updateRequestsNextCursorInStore, ({ nextCursor }) => {
    shiftRequestStore().nextCursor = nextCursor;
});